import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { AppVersionInfo, KeyValueItem } from '../../model/general.model';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'build-info-dialog',
  templateUrl: './build-info-dialog.component.html',
  styleUrls: ['./build-info-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class BuildInfoDialogComponent {
  private translate = inject(TranslateService);
  private data = inject<AppVersionInfo>(MAT_DIALOG_DATA);
  public dialogRef = inject(MatDialogRef<BuildInfoDialogComponent>);

  protected details: KeyValueItem[] = [
    { key: this.translate.instant('FRONTEND_VERSION'), value: this.data.feVersion },
    { key: this.translate.instant('BACKEND_VERSION'), value: this.data.beVersion },
  ];
}
